
























































































import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Viewpoints from "@/store/modules/Viewpoints";
import { Viewpoint } from "@/api/model/Viewpoint";
import Decisions from "@/store/modules/Decisions";

const workspaceOptions = getModule(WorkspaceOptions)
const viewpointModule = getModule(Viewpoints)
const decisionModule = getModule(Decisions);
@Component({
    components: {}
})
export default class ViewpointVisibilitySelectorMenu extends Vue {

    get viewpointList(): any[] {
        return viewpointModule.decisionViewpoints.sort((a,b) => {
            if (a.name === b.name) {
                return 1;
            }

            return a.name.localeCompare(b.name)  
        });
    }

    get selectedViewpointIds() {
        return viewpointModule.selectedViewpointIds;
    }

    get singularViewpointLabel() {
        return decisionModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionModule.pluralViewpointLabel;
    }

    private updateVisibility(choiceId: string, value: any) {
        workspaceOptions.changeChoiceVisibility({id: choiceId, value: value});
    }

    private selectViewpoint(viewpoint: Viewpoint) {
        if(this.selectedViewpointIds.includes(viewpoint.viewpointId)) {
            viewpointModule.deselectViewpoint(viewpoint.viewpointId);
        } else {
            viewpointModule.selectViewpoint(viewpoint.viewpointId);
        }
        // getModule(Dialogs).editViewpointVisibility(viewpoint.viewpointId);
    }

}
